import {FC, ReactNode} from "react"

import {useTranslation} from "@frontend/i18n"
import {css} from "@styled-system/css"
import {hstack} from "@styled-system/patterns"

interface MultipleChoiceOptionsProps {
  options: string[]
  onChooseOption: (option: string) => void
  compact?: boolean
  /** Optional element rendered as the first pill in the row. */
  leadingAction?: ReactNode
}

export const MultipleChoiceOptions: FC<MultipleChoiceOptionsProps> = ({
  options,
  onChooseOption,
  compact = false,
  leadingAction,
}) => {
  const t = useTranslation()
  return (
    <>
      <span
        className={css({
          color: "text.tertiary",
          textStyle: "captionRegular",
        })}
      >
        {t("conversation.quickResponses")}
      </span>
      <div className={hstack({justifyContent: "right"})}>
        <div
          className={css({
            display: "flex",
            flexDirection: "row",
            gap: compact ? 6 : 8,
            flexWrap: "wrap",
            justifyContent: "flex-end",
          })}
        >
          {leadingAction}
          {options.map((option) => (
            <button
              className={css({
                borderRadius: compact
                  ? "20px 20px 4px 20px"
                  : "24px 24px 4px 24px",
                borderWidth: compact ? 1.5 : 2,
                borderColor: "border.brand.primary",
                color: "text.brand.primary",
                paddingY: compact ? 7 : 10,
                paddingX: compact ? 12 : 16,
                backgroundColor: "background.brand.primarySubtle",
                textStyle: compact ? "bodyMedium" : "bodyLargeMedium",
              })}
              onClick={(): void => {
                onChooseOption(option)
              }}
              key={option}
            >
              {option}
            </button>
          ))}
        </div>
      </div>
    </>
  )
}
